import BaseObject from '../../base/base_object';
import {USER_EVENTS} from '../../events/events';

export default class LoginButtonsDependenciesFactory extends BaseObject {
    static CLASS = 'LoginButtonsDependenciesFactory';

    init(params) {
        this._serviceFactory = params.serviceFactory;
    }

    _serviceFactory = null;

    createLoginButtonClickObservable(button) {
        return this._createButtonClickObservable(button);
    }

    createRegisterButtonClickObservable(button) {
        return this._createButtonClickObservable(button);
    }

    _createButtonClickObservable(button) {
        return this._serviceFactory.observableFactoryService().fromEvent(button, USER_EVENTS.ON_CLICK);
    }

}